import { DetailsDisclosure } from '@/scripts/theme/details-disclosure';
import {qsaRequired, qsRequired, scaleValue} from '@/scripts/core/global';
import {type StickyHeader } from '@/scripts/theme/sticky-header';
import { SELECTORS } from '@/scripts/core/constants';

export class HeaderMenu extends DetailsDisclosure {
  static override htmlSelector = 'header-menu'
  header: StickyHeader | null
  opener: HTMLElement
  boundOnMouseLeave: EventListener
  constructor() {
    super()
    this.header = qsRequired<StickyHeader>(SELECTORS.headerWrapper)
    this.opener = qsRequired('summary', this)
    this.opener.addEventListener('mouseenter', this.onHover.bind(this))
    this.boundOnMouseLeave = this.onMouseLeave.bind(this)
  }

  override getContent() {
    return qsRequired('[data-uc-megamenu-content]', this)
  }

  onMouseLeave(event: Event) {
    this.mainDetailsToggle.open = false
    this.onToggle(event)
    this.content.removeEventListener('mouseleave', this.boundOnMouseLeave)
  }

  closeSiblings(event: Event) {
    const relatedEls = qsaRequired<HeaderMenu>('header-menu')
    const siblings = Array.from(relatedEls).filter((el) => el !== this)
    siblings.forEach((el) => {
      el.boundOnMouseLeave(event)
    })
  }

  onHover(event: Event) {
    this.closeSiblings(event)
    this.mainDetailsToggle.open = true
    this.onToggle(event)
    window.setTimeout(() => {
      this.content.addEventListener('mouseleave', this.boundOnMouseLeave)
    }, 1)
  }

  override onToggle(event: Event) {
    event.preventDefault()
    if (!this.header) return

    this.header.preventHide = this.mainDetailsToggle.open
    if (this.mainDetailsToggle.open) {
      // todo: when there is an animation, wrap this next line in a setTimeout
      this.classList.add('open')
    } else {
      this.classList.remove('open')
    }

    if (
        document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !==
        ''
    )
      return
    const viewport = window.innerWidth >= 750 ? 'desktop' : 'mobile'
    document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `calc(${scaleValue(this.header.getBoundingClientRect().bottom, viewport)} * var(--ax))`
    )
  }
}
